import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['container', 'lightRadio', 'darkRadio']

  declare readonly containerTarget: HTMLDivElement
  declare readonly lightRadioTarget: HTMLInputElement
  declare readonly darkRadioTarget: HTMLInputElement

  connect (): void {
    const isGlobalDark = document.documentElement.classList.contains('dark')
    this.darkRadioTarget.checked = isGlobalDark
    this.lightRadioTarget.checked = !isGlobalDark
    this.applyMode()
    this.containerTarget.classList.add('mode-initialized')
  }

  applyMode (): void {
    const isDark = this.darkRadioTarget.checked
    this.containerTarget.classList.toggle('mode-dark', isDark)
    this.containerTarget.classList.toggle('light', !isDark)
  }

  switchMode (): void {
    this.applyMode()
  }
}
